import React, { forwardRef } from 'react';

import { CalendarIcon } from 'components/icons';
import { datePickerButton } from './scss/Datepicker.module.scss';

const DatePickerButton = ({ value, onClick }, _ref) => (
  <button className={datePickerButton} onClick={onClick}>
    <CalendarIcon />
    <span>{value}</span>
  </button>
);

export default forwardRef(DatePickerButton);
